/** Получить бэграунд карточки */
export const getBackground = (image?: string, gradient?: string) => {
    const background = [];

    if (image) background.push(`url(${image})`);
    if (gradient) background.push(gradient);

    return background.join(', ');
};
